import React from 'react';

export const ShieldExclamationIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.167}
      d="M8.942 5.333V8m5.334-1.223c0 4.378-3.313 6.342-4.717 6.977l-.001.001c-.148.067-.222.1-.39.13a1.87 1.87 0 0 1-.451 0 1.342 1.342 0 0 1-.392-.13c-1.404-.636-4.716-2.6-4.716-6.978V4.133c0-.746 0-1.12.145-1.405.128-.251.332-.455.583-.583C4.622 2 4.996 2 5.742 2h6.4c.747 0 1.12 0 1.405.145.251.128.455.332.583.583.146.285.146.658.146 1.403v2.646ZM8.976 10v.067h-.067V10h.066Z"
    />
  </svg>
);
